<div class="notification-panel-inner" data-test="notification-panel">
  <header class="notification-panel-header">
    <span class="notification-panel-title">{{ "knowledge.notifications.title" | translate }}</span>

    @if (state().unreadCount > 0) {
      <span class="notification-panel-count">
        {{ "knowledge.notifications.unread-count" | translate: { count: state().unreadCount } }}
      </span>
    }
  </header>

  <mat-progress-bar class="notification-panel-progress" mode="indeterminate" [class.notification-panel-progress-hidden]="!state().loading"></mat-progress-bar>

  @if (state().rows.length === 0 && !state().loading) {
    <div class="notification-panel-empty" data-test="notification-panel-empty">
      <span class="notification-panel-empty-glyph material-symbols-outlined" aria-hidden="true">notifications</span>
      <p class="notification-panel-empty-text">
        @if (state().hasError) {
          {{ "generic.error" | translate }}
        } @else {
          {{ "knowledge.notifications.empty-panel" | translate }}
        }
      </p>
    </div>
  } @else {
    <div class="notification-panel-list">
      @for (row of state().rows; track row.item.id) {
        @if (row.link) {
          <a mat-menu-item class="notification-panel-row" [routerLink]="row.link" (click)="activated.emit(row)" [attr.data-test]="row.dataTest">
            <app-knowledge-notification-row [row]="row"></app-knowledge-notification-row>
          </a>
        } @else {
          <!-- No destination this build can address, but still clickable: disabling it would leave an
               unread row the reader has no way to clear. -->
          <button mat-menu-item type="button" class="notification-panel-row" (click)="activated.emit(row)" [attr.data-test]="row.dataTest">
            <app-knowledge-notification-row [row]="row"></app-knowledge-notification-row>
          </button>
        }
      }
    </div>
  }

  <div class="notification-panel-footer">
    @if (state().hasError) {
      <!-- The mat-menu panel closes on any click inside it; a retry has to leave it open. -->
      <button mat-menu-item type="button" (click)="$event.stopPropagation(); retryRequested.emit()" data-test="notification-panel-retry">
        {{ "generic.retry" | translate }}
      </button>
    }

    @if (state().canMarkAll) {
      <button mat-menu-item type="button" (click)="$event.stopPropagation(); markAllRequested.emit()" data-test="notification-mark-all">
        {{ "knowledge.notifications.mark-all" | translate }}
      </button>
    }

    <a mat-menu-item routerLink="/knowledge/notifications" data-test="notification-show-all">
      {{ "knowledge.notifications.show-all" | translate }}
    </a>

    @switch (state().push) {
      @case ("off") {
        <button
          mat-menu-item
          type="button"
          [disabled]="state().pushPending"
          (click)="$event.stopPropagation(); pushToggled.emit()"
          data-test="notification-push-toggle">
          {{ "knowledge.notifications.push.enable" | translate }}
        </button>
      }
      @case ("promptRequired") {
        <button
          mat-menu-item
          type="button"
          [disabled]="state().pushPending"
          (click)="$event.stopPropagation(); pushToggled.emit()"
          data-test="notification-push-toggle">
          {{ "knowledge.notifications.push.enable" | translate }}
        </button>
      }
      @case ("on") {
        <button
          mat-menu-item
          type="button"
          [disabled]="state().pushPending"
          (click)="$event.stopPropagation(); pushToggled.emit()"
          data-test="notification-push-toggle">
          {{ "knowledge.notifications.push.disable" | translate }}
        </button>
      }
      @case ("blocked") {
        <p class="notification-panel-push-note" data-test="notification-push-blocked">
          {{ "knowledge.notifications.push.blocked" | translate }}
        </p>
      }
    }
  </div>
</div>
